
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexoyU5h2jze1WS29zMa5jX2G9iHQzELJoyRgldwOf3NtsMeta } from "/app-sources/pages/index.vue?macro=true";
import { default as loginsibgiOdaiVPWWfzxbtTpUab5DBF7pA3SLTKXLcj01ggMeta } from "/app-sources/pages/login.vue?macro=true";
import { default as verifytI0b7C7340bX0FrAWAykxlIz_zW9o4WLvNALVHx7fngMeta } from "/app-sources/pages/verify.vue?macro=true";
import { default as checkoutoWokLr_45Ix64PGDzreVrAa65TmxuugOUEatoITM2aAX4Meta } from "/app-sources/pages/checkout.vue?macro=true";
import { default as registerHqyPqX3y_gY5VM_5HZqjepR1kucW4D9xQULQYFlDUjQMeta } from "/app-sources/pages/register.vue?macro=true";
import { default as settingslHM3pmIyfYn99Z5cm9EVE1SplDp8wDNQ8zNjigFqFsIMeta } from "/app-sources/pages/settings.vue?macro=true";
import { default as calendarsjc6YTkyVH4TMGtGiwwPwvJ35CEVVUkVuDRhoMLLUMl8Meta } from "/app-sources/pages/calendars.vue?macro=true";
import { default as onboardingoB_45QmwiFOe7khgzg5lOK3NVgPnZ_EmeG7U3ygawMn3EMeta } from "/app-sources/pages/onboarding.vue?macro=true";
import { default as _91slug_93EfKd7DJB9E8L1BfO5BdJr0uuyecWpFUsUXedzpX1TUIMeta } from "/app-sources/pages/help/[slug].vue?macro=true";
import { default as password_45resetCnOoSnYWjJpUUOGI1CQtmUVvw5wJX1953s9_2UypS6QMeta } from "/app-sources/pages/password-reset.vue?macro=true";
import { default as index_KR_45VKWf_Cw4BONjWZx8alMaF7jMgXtBNzUSQK_toKAMeta } from "/app-sources/pages/dashboard/index.vue?macro=true";
import { default as index4NVbWPX9rfknfQfz3rf6LVGIPzQkgi65ThXUr0F8uLMMeta } from "/app-sources/pages/dev-diary/index.vue?macro=true";
import { default as _91slug_9337f2_HWis0_45T71nchpFsrSvOpOW_45z93NUNaCc65Si3YMeta } from "/app-sources/pages/dev-diary/[slug].vue?macro=true";
import { default as adminIAatNfwgUbUdLS_LJCgwU3DBX_cMZvzfmKpZI2veIX4Meta } from "/app-sources/pages/marketplace/admin.vue?macro=true";
import { default as indexIjCxpqNq5mdhkznBBDC27M7vo_VvWqnw_457ybelKfP4IMeta } from "/app-sources/pages/marketplace/index.vue?macro=true";
import { default as indexOTjNQB5LcVbplu3gPn8gZOaSbxnAHHKxBwM9vUTIJNsMeta } from "/app-sources/pages/availability/index.vue?macro=true";
import { default as indexPNKzQEazufHtZqCk1i5Edn6PD2J7h7MDWuZ4_DUZs2AMeta } from "/app-sources/pages/payment-error/index.vue?macro=true";
import { default as bookings5UFZ4yJTsnHUQh8ztgQQCR3dk6Ep67yLUyVMUlCeDocMeta } from "/app-sources/pages/availability/bookings.vue?macro=true";
import { default as _91subdomain_93O7k3L7dJi0wTOj3z4KvYaAOVPiUabK62XzZfjwfwRqUMeta } from "/app-sources/pages/dashboard/[subdomain].vue?macro=true";
import { default as indexBsfZNf_45YOSQSNya4fsLS_456REX_bVRg9wIRFZksOu1tkMeta } from "/app-sources/pages/dashboard/admin/index.vue?macro=true";
import { default as indexYCSo7qKxJG0_s2PkA0OoTIXnupPlRUpl0lcw1nlLdYwMeta } from "/app-sources/pages/payment-success/index.vue?macro=true";
import { default as resourceskcynYGQsmpey89aZe3_F7J4yzuEUQEbILwTda20xKaYMeta } from "/app-sources/pages/availability/resources.vue?macro=true";
import { default as indexI_5QzuDa8Sx_45Vu9u2_45TWajWTUC9bloTN4PvGfEvQcjYMeta } from "/app-sources/pages/dashboard/admin/users/index.vue?macro=true";
import { default as indexX8u56udXllXVfu3HJ_45c9BVcy8ynRc_453va2svdlZLpWYMeta } from "/app-sources/pages/dashboard/admin/activities/index.vue?macro=true";
import { default as index7gD_7QqtiE4BsWnCp70yU2BZBvbD2eEN9MCnas_uCPQMeta } from "/app-sources/pages/[catalog_id]/[catalog_slug]/index.vue?macro=true";
import { default as index913vDviY6XVCjqJ49OA6hqA8Vtue6UqEwg0KPIbBOSgMeta } from "/app-sources/pages/dashboard/admin/activity-types/index.vue?macro=true";
import { default as _91slug_93sw5CTgyQuCBhusqlAB2jTzhnHiYmopAOZOZSP0n2AYUMeta } from "/app-sources/pages/[catalog_id]/[catalog_slug]/[id]/[slug].vue?macro=true";
export default [
  {
    name: "index___it",
    path: "/",
    component: () => import("/app-sources/pages/index.vue")
  },
  {
    name: "login___it",
    path: "/login",
    meta: loginsibgiOdaiVPWWfzxbtTpUab5DBF7pA3SLTKXLcj01ggMeta || {},
    component: () => import("/app-sources/pages/login.vue")
  },
  {
    name: "verify___it",
    path: "/verify",
    component: () => import("/app-sources/pages/verify.vue")
  },
  {
    name: "checkout___it",
    path: "/checkout",
    component: () => import("/app-sources/pages/checkout.vue")
  },
  {
    name: "register___it",
    path: "/register",
    meta: registerHqyPqX3y_gY5VM_5HZqjepR1kucW4D9xQULQYFlDUjQMeta || {},
    component: () => import("/app-sources/pages/register.vue")
  },
  {
    name: "settings___it",
    path: "/settings",
    meta: settingslHM3pmIyfYn99Z5cm9EVE1SplDp8wDNQ8zNjigFqFsIMeta || {},
    component: () => import("/app-sources/pages/settings.vue")
  },
  {
    name: "calendars___it",
    path: "/calendars",
    meta: calendarsjc6YTkyVH4TMGtGiwwPwvJ35CEVVUkVuDRhoMLLUMl8Meta || {},
    component: () => import("/app-sources/pages/calendars.vue")
  },
  {
    name: "onboarding___it",
    path: "/onboarding",
    meta: onboardingoB_45QmwiFOe7khgzg5lOK3NVgPnZ_EmeG7U3ygawMn3EMeta || {},
    component: () => import("/app-sources/pages/onboarding.vue")
  },
  {
    name: "help-slug___it",
    path: "/help/:slug()",
    meta: _91slug_93EfKd7DJB9E8L1BfO5BdJr0uuyecWpFUsUXedzpX1TUIMeta || {},
    component: () => import("/app-sources/pages/help/[slug].vue")
  },
  {
    name: "password-reset___it",
    path: "/password-reset",
    meta: password_45resetCnOoSnYWjJpUUOGI1CQtmUVvw5wJX1953s9_2UypS6QMeta || {},
    component: () => import("/app-sources/pages/password-reset.vue")
  },
  {
    name: "dashboard___it",
    path: "/dashboard",
    meta: index_KR_45VKWf_Cw4BONjWZx8alMaF7jMgXtBNzUSQK_toKAMeta || {},
    component: () => import("/app-sources/pages/dashboard/index.vue")
  },
  {
    name: "dev-diary___it",
    path: "/dev-diary",
    meta: index4NVbWPX9rfknfQfz3rf6LVGIPzQkgi65ThXUr0F8uLMMeta || {},
    component: () => import("/app-sources/pages/dev-diary/index.vue")
  },
  {
    name: "dev-diary-slug___it",
    path: "/dev-diary/:slug()",
    meta: _91slug_9337f2_HWis0_45T71nchpFsrSvOpOW_45z93NUNaCc65Si3YMeta || {},
    component: () => import("/app-sources/pages/dev-diary/[slug].vue")
  },
  {
    name: "marketplace-admin___it",
    path: "/marketplace/admin",
    meta: adminIAatNfwgUbUdLS_LJCgwU3DBX_cMZvzfmKpZI2veIX4Meta || {},
    component: () => import("/app-sources/pages/marketplace/admin.vue")
  },
  {
    name: "marketplace___it",
    path: "/marketplace",
    meta: indexIjCxpqNq5mdhkznBBDC27M7vo_VvWqnw_457ybelKfP4IMeta || {},
    component: () => import("/app-sources/pages/marketplace/index.vue")
  },
  {
    name: "availability___it",
    path: "/availability",
    meta: indexOTjNQB5LcVbplu3gPn8gZOaSbxnAHHKxBwM9vUTIJNsMeta || {},
    component: () => import("/app-sources/pages/availability/index.vue")
  },
  {
    name: "payment-error___it",
    path: "/payment-error",
    meta: indexPNKzQEazufHtZqCk1i5Edn6PD2J7h7MDWuZ4_DUZs2AMeta || {},
    component: () => import("/app-sources/pages/payment-error/index.vue")
  },
  {
    name: "availability-bookings___it",
    path: "/availability/bookings",
    meta: bookings5UFZ4yJTsnHUQh8ztgQQCR3dk6Ep67yLUyVMUlCeDocMeta || {},
    component: () => import("/app-sources/pages/availability/bookings.vue")
  },
  {
    name: "dashboard-subdomain___it",
    path: "/dashboard/:subdomain()",
    meta: _91subdomain_93O7k3L7dJi0wTOj3z4KvYaAOVPiUabK62XzZfjwfwRqUMeta || {},
    component: () => import("/app-sources/pages/dashboard/[subdomain].vue")
  },
  {
    name: "admin-dashboard___it",
    path: "/dashboard/admin",
    meta: indexBsfZNf_45YOSQSNya4fsLS_456REX_bVRg9wIRFZksOu1tkMeta || {},
    component: () => import("/app-sources/pages/dashboard/admin/index.vue")
  },
  {
    name: "payment-success___it",
    path: "/payment-success",
    meta: indexYCSo7qKxJG0_s2PkA0OoTIXnupPlRUpl0lcw1nlLdYwMeta || {},
    component: () => import("/app-sources/pages/payment-success/index.vue")
  },
  {
    name: "availability-resources___it",
    path: "/availability/resources",
    meta: resourceskcynYGQsmpey89aZe3_F7J4yzuEUQEbILwTda20xKaYMeta || {},
    component: () => import("/app-sources/pages/availability/resources.vue")
  },
  {
    name: "admin-users___it",
    path: "/dashboard/admin/users",
    meta: indexI_5QzuDa8Sx_45Vu9u2_45TWajWTUC9bloTN4PvGfEvQcjYMeta || {},
    component: () => import("/app-sources/pages/dashboard/admin/users/index.vue")
  },
  {
    name: "admin-activities___it",
    path: "/dashboard/admin/activities",
    meta: indexX8u56udXllXVfu3HJ_45c9BVcy8ynRc_453va2svdlZLpWYMeta || {},
    component: () => import("/app-sources/pages/dashboard/admin/activities/index.vue")
  },
  {
    name: "catalog_id-catalog_slug___it",
    path: "/:catalog_id()/:catalog_slug()",
    component: () => import("/app-sources/pages/[catalog_id]/[catalog_slug]/index.vue")
  },
  {
    name: "admin-activity-types___it",
    path: "/dashboard/admin/activity-types",
    meta: index913vDviY6XVCjqJ49OA6hqA8Vtue6UqEwg0KPIbBOSgMeta || {},
    component: () => import("/app-sources/pages/dashboard/admin/activity-types/index.vue")
  },
  {
    name: "catalog_id-catalog_slug-id-slug___it",
    path: "/:catalog_id()/:catalog_slug()/:id()/:slug()",
    component: () => import("/app-sources/pages/[catalog_id]/[catalog_slug]/[id]/[slug].vue")
  }
]